

  function openNav() {
          document.getElementById("mySidebar").style.left = "0px";
          document.getElementById("sidebar_container_blur_bg").style.right = "0vw";
        }  
        function closeNav() {
          document.getElementById("mySidebar").style.left = "-100vw"; 
          document.getElementById("sidebar_container_blur_bg").style.right = "-105vw";
          }

           function handleMousePos(event) {
      var mouseClickWidth = event.clientX;
      if(mouseClickWidth>=280){
            document.getElementById("mySidebar").style.left = "-100vw";
            document.getElementById("sidebar_container_blur_bg").style.right = "-105vw";
           }
}

document.addEventListener("click", handleMousePos);


function close_popup() {
          document.getElementById("pop").style.display = "none";
        }


$('.sec1_home').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  prevArrow:'',
  nextArrow:''
});


$('.sec5_home_slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  centerMode: true,
  centerPadding: '180px',
  prevArrow:'<i class="fal fa-arrow-left sec5_home_slider_left"></i>',
  nextArrow:'<i class="fal fa-arrow-right sec5_home_slider_right"></i>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        centerPadding: '100px',
      }
    },
    {
      breakpoint: 1023,
      settings: {
        centerPadding: '40px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        centerPadding: '20px',
        slidesToShow: 1
      }
    }
  ]
});



$('.sec6_home_slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  prevArrow:'',
  nextArrow:'',
  autoplay:true,
  autoplaySpeed:2000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});




$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.slider-nav',
    prevArrow:'<i class="fal fa-arrow-left prod_slider_left"></i>',
    nextArrow:'<i class="fal fa-arrow-right prod_slider_right"></i>',
});
$('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    }
    ]
});

/* Loop through all dropdown buttons to toggle between hiding and showing its dropdown content - This allows the user to have multiple dropdowns without any conflict */
var dropdown = document.getElementsByClassName("dropdown-btn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var dropdownContent = this.nextElementSibling;
    if (dropdownContent.style.display === "block") {
      dropdownContent.style.display = "none";
    } else {
      dropdownContent.style.display = "block";
    }
  });
}

 $(document).ready(function() {
     $(".add_to_cart").on('click', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        $(".error_message").html("You must agree with the terms and conditions.");
        return false;
      }
    });
  });
$(document).ready(function() {
     $("#agree").on('change', function() {
      if ($('#agree').is(':checked')) {
        $(".error_message").html("");
      }
      else {
        $(".error_message").html("");
        return false;
      }
    });
  });

